import React from 'react';
import { Button, Form, Input, message } from 'antd';
import { useChangePasswordMutation } from '../../queries/me';
import { Card, CardHead } from '../../components';

export default function PasswordCard() {
  const [form] = Form.useForm();
  const { mutate, isPending } = useChangePasswordMutation();

  const save = ({ currentPassword, newPassword }) =>
    mutate(
      { currentPassword, newPassword },
      {
        onSuccess: () => {
          message.success('Password updated');
          form.resetFields();
        },
        onError: (err) => message.error(err.response?.data?.message || 'Failed to update password')
      }
    );

  return (
    <Card aria-labelledby="password-title">
      <CardHead>
        <h2 id="password-title">Change password</h2>
        <span>your account</span>
      </CardHead>
      <Form form={form} layout="vertical" onFinish={save} requiredMark={false}>
        <Form.Item name="currentPassword" label="Current password" rules={[{ required: true }]}>
          <Input.Password autoComplete="current-password" />
        </Form.Item>
        <Form.Item
          name="newPassword"
          label="New password"
          rules={[{ required: true, min: 8, message: 'At least 8 characters' }]}
        >
          <Input.Password autoComplete="new-password" />
        </Form.Item>
        <Form.Item
          name="confirm"
          label="Confirm new password"
          dependencies={['newPassword']}
          rules={[
            { required: true },
            ({ getFieldValue }) => ({
              validator: (_, value) =>
                !value || value === getFieldValue('newPassword')
                  ? Promise.resolve()
                  : Promise.reject(new Error('Passwords do not match'))
            })
          ]}
        >
          <Input.Password autoComplete="new-password" />
        </Form.Item>
        <Button type="primary" htmlType="submit" loading={isPending}>
          Update password
        </Button>
      </Form>
    </Card>
  );
}
